import React, { useState } from 'react';
import styled from 'styled-components';
import CartPaymentMethodContainer from '../../Cart/CartPaymentMethod/CartPaymentMethodContainer';
import { PrimaryButton } from '../../../components/Buttons';
import { Formik } from 'formik';
import appConfig from '../../../../app-config';
import TextField from '@material-ui/core/TextField';
const Wrapper = styled.div`
  display: grid;
  grid-gap: 24px;
`;

const ContentWrapper = styled.div`
  display: grid;
  grid-gap: 8px;
`;

const TitleWrapper = styled.p`
  text-transform: capitalize;
  margin-bottom: auto;
  font-size: 16px;
  font-family: ${(props) => props.theme.secondaryFontFontFamily};
`;

const FundWrapper = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-gap: 20px;
  margin-bottom: 30px;
`;

const FundBox = styled.div`
  cursor: pointer;
  height: 48px;
  width: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.03px;
  color: ${(props) =>
    props.isSelected
      ? props.theme.tipBoxSelectedTextColour
      : props.theme.tipBoxTextColour};
  background-color: ${(props) =>
    props.isSelected
      ? props.theme.tipSelectedBackgroundColor
      : props.theme.tipBackgroundColor};
  font-family: ${(props) => props.theme.primaryFontFontFamily};

  :hover {
    background-color: ${(props) =>
      props.isSelected
        ? props.theme.tipBoxSelectedColorHover
        : props.theme.tipBoxColorHover};
    color: ${(props) =>
      props.isSelected && props.theme.tipBoxSelectedTextHover};
    transition: all 0.25s ease;
  }

  @media (max-width: 786px) {
    width: 60px;
  }
`;

const CustomFundInput = styled.input`
  width: 80px;
  background: inherit;
  border-radius: 8px;
  text-align: center;
  border: 1px solid #d8d8d8;

  &:focus {
    outline: none;
  }

  @media (max-width: 786px) {
    width: 50px;
  }
`;

const Button = styled(PrimaryButton)`
  height: 56px;
  width: 392px;
  border-radius: ${(props) => props.theme.giftCardButtonRadius};
`;

const GiftCardImage = styled.img`
  width: 253px;
  height: 168px;
  border-radius: 16px;
`;

const fundAmtList = [10, 20, 35];

const AddNewGiftCard = ({ handleAddFunds, paymentMethod, sourceConfig }) => {
  const { gift_card } = sourceConfig;
  const [updatedFundAmt, setUpdatedFundAmt] = useState(0.0);
  return (
    <Wrapper>
      <div style={{ textAlign: 'center' }}>
        <GiftCardImage src={appConfig.styleConfig.giftCardImage} />
      </div>
      <ContentWrapper>
        <TitleWrapper id='AddNewGiftCartd-Title'>Card Balance</TitleWrapper>
        <div style={{ fontSize: '28px', fontWeight: '600' }}>
          {' '}
          ${updatedFundAmt}
        </div>
      </ContentWrapper>
      <ContentWrapper>
        <TitleWrapper id='AddFunds-Title'>Add Funds</TitleWrapper>
        <Formik
          initialValues={{
            fundAmt: '',
            paymentMethod: paymentMethod,
            cvv: gift_card?.payment_cvv_required ? '' : undefined,
          }}
          validate={(values) => {
            let errors = {};
            if (!values.fundAmt) {
              errors.fundAmt = 'Required';
            } else if (values.fundAmt < 5) {
              errors.fundAmt = 'Cannot be less than $5';
            }
            if (!values.cvv && gift_card?.payment_cvv_required) {
              errors.cvv = 'Required';
            }
            if (values?.cvv?.length > 4) {
              errors.cvv = 'CVV must be less than 4 digits';
            }
            return errors;
          }}
          validateOnBlur={false}
          onSubmit={(values) => handleAddFunds(values)}
          enableReinitialize
        >
          {({
            values,
            errors,
            touched,
            handleSubmit,
            setFieldValue,
            handleChange,
            isValid,
          }) => (
            <form onSubmit={handleSubmit}>
              <FundWrapper>
                {fundAmtList.map((fundAmt) => {
                  const isSelected = fundAmt == values.fundAmt;
                  return (
                    <FundBox
                      id='AddNewGiftCartd-FundBox'
                      onClick={() => {
                        setFieldValue('fundAmt', fundAmt);
                        setUpdatedFundAmt(fundAmt);
                      }}
                      isSelected={isSelected}
                    >
                      ${fundAmt}
                    </FundBox>
                  );
                })}
                <CustomFundInput
                  id='AddNewGiftCartd-CustomFundInput'
                  onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                  value={values.fundAmt === -1 ? '' : values.fundAmt}
                  onChange={(e) => {
                    setFieldValue('fundAmt', e.target.value);
                    setUpdatedFundAmt(e.target.value);
                  }}
                  error={touched.fundAmt && errors.fundAmt ? true : false}
                  helperText={touched.fundAmt && errors.fundAmt}
                  type='number'
                  placeholder='Other'
                  min='5'
                  maxLength='3'
                />
              </FundWrapper>
              <CartPaymentMethodContainer isForGiftCard={true} />
              {gift_card?.payment_cvv_required && (
                <TextField
                  id='ReloadGiftCard-CVV'
                  variant='outlined'
                  name='cvv'
                  value={values.cvv}
                  onKeyDown={(e) => {
                    if (
                      e.key !== 'Backspace' &&
                      e.key !== 'Tab' &&
                      e.key !== 'Delete' &&
                      e.key !== 'ArrowLeft' &&
                      e.key !== 'ArrowRight' &&
                      (e.key < '0' || e.key > '9')
                    ) {
                      e.preventDefault();
                    }
                  }}
                  onChange={handleChange}
                  type='text'
                  label='CVV'
                  placeholder='CVV'
                  required
                  fullWidth
                  style={{ marginBottom: '20px' }}
                  error={errors.cvv}
                  helperText={errors.cvv}
                  maxLength={4}
                />
              )}
              <Button
                id='AddNewGiftCartd-AddFunds'
                type='submit'
                disabled={!isValid || paymentMethod?.type === 'gift_card'}
              >
                Create a Digital Gift Card
              </Button>
            </form>
          )}
        </Formik>
      </ContentWrapper>
    </Wrapper>
  );
};

export default AddNewGiftCard;
